import { useEffect, useState } from "react"
import { getMatrix, importMatrix } from "../Services";
import {
  Button,
  Flex,
  Spacer,
  useBoolean,
  Spinner,
  useToast,
  Box,
  Select,
  Input
} from '@chakra-ui/react';
import { Theme } from "../Theme";
import { BiSave } from "react-icons/bi";
import List from "./List";

const validMime = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];

const Enquiry = () => {
  const [loader, setLoader] = useBoolean();
  const [matrix, setMatrix] = useState();
  const [roles, setRoles] = useState();
  const [role, setRole] = useState();
  const [file, setFile] = useState();
  const [isValid, setIsValid] = useState(false);
  const toast = useToast();

  const getData = () => {
    setLoader.on();
    getMatrix()
      .then(results => {
        setMatrix(results?.matrix);
        setRoles(results?.roles);
        if (!!results.roles) {
          setRole(results.default_role);
        }
      })
      .catch(error => {
        setMatrix([]);
        setRoles([])
      })
      .finally(_ => setLoader.off());
  }

  const onLoadFile = (files) => {
    console.log(files);
    if (!validMime.includes(files[0].type)) {
      toast({
        position: 'bottom-right',
        status: 'warning',
        isClosable: true,
        title: 'Only excel file are accepted'
      });
      setIsValid(false);
    } else {
      setIsValid(true);
      setFile(files[0]);
    }

  }

  const onImportFile = () => {
    setLoader.on();
    importMatrix(file)
      .then(response => {
        toast({
          position: 'bottom-right',
          status: 'success',
          isClosable: true,
          title: 'Import matrix completed successfully'
        })
        getData();
      })
      .catch(error => {
        toast({
          position: 'bottom-right',
          status: 'error',
          isClosable: true,
          title: 'We are sorry, an error occured when importing matrix, ' + error.message
        })
      })
      .finally(_ => setLoader.off());
  }

  useEffect(() => {
    getData()
  }, [])

  return (<>
    <Flex background={'#e9e9e9'} direction={'row'} p={2} alignItems={'flex-end'} justifyContent={'flex-end'}>
      <Input type="file" size='sm' mr={2} onChange={(event) => onLoadFile(event.target.files)} />
      <Button disabled={!isValid} onClick={onImportFile} size={'sm'} colorScheme='blue'>
        Import Matrix
      </Button>
    </Flex>
    <Box style={Theme.Container}>
      <Flex p={2}>
        {(!!roles) ?
          <Select value={role} onChange={(event) => setRole(event.target.value)}>
            {Object.entries(roles).map(role => <option key={role[0]} value={role[0]}>{role[1]}</option>)}
          </Select> : null}
      </Flex>
      <List dataset={matrix?.filter(row => row.roles.indexOf(role) > -1)} />
    </Box>
    {(loader) ? <Flex style={Theme.Loader}><Spinner size={'lg'} /></Flex> : null}
  </>)
}

export default Enquiry;